
<template>
  <button v-on:click="submit">  点击</button>
</template>
  <script>


export default {
  data() {
    return {

      }

  },
  methods: {
    submit() {
      let time1 = parseInt(new Date().getTime()) + '';
      for (let i=1;i<10;i++){
        let nonce = Math.round(Math.random() * 100000000000)

        this.$axios.post('api/openapi/v1/material/page/video?access_token=3a2dc6872c899601a2d5b470cdf797284007eebce43e275e85dc484ed03d0aa5&timestamp='+time1+'&nonce='+nonce+'&advertiser_id=8abd39c69363441438cd',
          {
            "pageIndex": i,
            "pageSize": 100
          }).then(res=>{
          console.log(i)
          for (let k in res.data.data.list){
            console.log(res.data.data.list[k].fileFullPath)
          }
          //推广计划id id
        })
      }
      }

  }
}
</script>
<style>
.top1{
  position: absolute;
  top: 200px;
  width: 100%;
  /*left: 20%;*/
}
</style>



// WEBPACK FOOTER //
// src/components/login/talk.vue